import { ConsolidatedLocationView, EventPanelMetadata } from '@mark43/cad-api';
import { useWatch } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useBootstrapState } from '../../../bootstrap/bootstrap-provider';
import { useEventMetadataStore } from '../../../event-panel/event-panel-form/event-metadata';
import { useEventLocationCautionsQuery } from '../../../event-panel/event-state/use-event-location-cautions-query';
import { useUnitAssignment } from '../../../unit-assignment/unit-assignment-context';
import { useIntegratedForm } from '../../../forms/use-integrated-form';

/**
 * Hook to get the data needed to disposition an event, shared by the clear, unassign, and edit-disposition
 * pages. These pages all operate on the event in the route (`:eventId`).
 */
export const useUnitDispositionContent = () => {
    const params = useParams();
    const unitAssignment = useUnitAssignment();
    const { eventPanelOptions } = useBootstrapState();
    const { agencyId, agencyTypeGlobalAttrId } =
        useEventMetadataStore().state.metadata ?? ({} as EventPanelMetadata);

    const eventId = Number(params.eventId);

    if (isNaN(eventId)) {
        throw new Error('Invalid event ID');
    }

    // active unit whether there is an assignment or not
    const unitId = unitAssignment?.unitId;

    const isPrimaryUnitForAssignedEvent =
        eventId === unitAssignment?.assignedEvent?.eventId
            ? !!unitAssignment?.isPrimary
            : undefined;

    const eventForm = useIntegratedForm().form;

    const dispositionOptions = eventPanelOptions?.dispositionOptions;

    const { data: cautions, isLoading: areCautionsLoading } = useEventLocationCautionsQuery({
        eventId,
    });

    const eventLocation = useWatch({
        control: eventForm.control,
        name: 'location',
    }) as ConsolidatedLocationView;

    return {
        eventId,
        unitId,
        isPrimaryUnitForAssignedEvent,
        dispositionOptions,
        agencyId,
        agencyTypeGlobalAttrId,
        cautions,
        areCautionsLoading,
        eventLocation,
        eventForm,
    };
};
